/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Validator } from '@squiz/dxp-console-support';
import { isSetNamespaceRestricted } from '../IsSetNamespaceRestricted/IsSetNamespaceRestricted';

/**
 * Validates a value against a Component Set Webpath regular expression.
 * @export
 * @class ComponentSetWebpathValidator
 * @extends {Validator<string, R>}
 * @template R
 */
export class ComponentSetWebpathValidator<R> extends Validator<string, R> {
  public doValidate(value: string): boolean {
    const webpathExpression = /^[a-zA-Z0-9-]+$/g;

    if (isSetNamespaceRestricted(value)) {
      return false;
    }

    // Return test results for webpath string against expression
    return webpathExpression.test(String(value).trim());
  }
}
